import type React from 'react'
import styles from './PlainTextHeader.module.css'

/** Section keys per spec §7 — keep stable; they form the a11y-id contract. */
export type SectionKey = 'transfers' | 'exits-and-map' | 'facilities' | 'first-and-last-train'

export interface PlainTextHeaderProps {
  title: string
  /** Stable key for the `station-details-section-{key}` a11y id (spec §7). */
  sectionKey: SectionKey
}

/**
 * Plain section-header row — Figma SD/PlainTextHeader (6970:29525).
 * Section title `regularPx14` / text-secondary. a11y id
 * `station-details-section-{key}` (spec §7).
 */
export function PlainTextHeader({ title, sectionKey }: PlainTextHeaderProps): React.ReactElement {
  return (
    <h2 className={styles.header} data-testid={`station-details-section-${sectionKey}`}>
      {title}
    </h2>
  )
}
